import {
  Button,
  Col,
  Form,
  List,
  Row,
  Space,
  Spin,
  Tooltip,
  Upload,
  message,
} from "antd";
import {InputFields, ModalCustom, PdfViewer} from "components/common";
import React, {useEffect, useRef, useState} from "react";
import {dataFields} from "./config";
// import {glassStoreService} from "api";
import {employeeService} from "api";
import Notification from "components/common/notification/notification";
import {create} from "domain";
import {fields} from "pages/Pay/PendingTab/data.config";
import {RangePickerProps} from "antd/es/date-picker";
import moment from "moment";
import {dataFields as inputFieldsInit} from "./config";
import {
  DeleteOutlined,
  DownloadOutlined,
  EyeOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {FORMAT_TIME} from "types/enums";
import {items} from "pages/NurseOut/config";
import {
  convertIosStringToDateDayjs,
  convertIosStringToDateObjectDayjs,
  formatDateToString,
} from "helper/common";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setDetailDoc} from "redux/reducer/employee";
import dayjs from "dayjs";
const InfoDoc = props => {
  const {data, closeModal, type, getListApi, setData} = props;
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const modalRef = useRef<any>();
  const detailDoc = useAppSelector(state => state.employeesReducer.detailDoc);
  const [loadingFile, setLoadingFile] = useState(false);
  const [form] = Form.useForm();
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  useEffect(() => {
    if (detailDoc) {
      form.setFieldsValue({
        ...detailDoc,
        ngayThangNamVanBan: convertIosStringToDateDayjs(
          detailDoc?.ngayThangNamVanBan
        ),
        
      });
    } else {
      form.resetFields();
    }
   // console.log(detailDoc);
  }, [detailDoc]);

  //Thêm mới
  const submit = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        //id: data?.id,
        ngayThangNamVanBan: formatDateToString(
          value?.ngayThangNamVanBan,
          FORMAT_TIME.dateTime_4
        ),
      };
     // console.log("params",params);
      const res = await employeeService.updateTextAway(params);
      if (res.code === "400") {
        Notification("error", res.message);
      } else {
        Notification("success", `Đã thêm mới văn bản đi thành công  `);
      }
      dispatch(setDetailDoc(res?.data));
      setLoading(false);
      getListApi();
      closeModal();
    } catch (error) {
      setLoading(false);
      Notification("error", `Đã có lỗi khi thêm mới văn bản đi`);
    }
  };
  //Sửa
  const updateStore = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        id: detailDoc.id,
        ngayThangNamVanBan: formatDateToString(
          value?.ngayThangNamVanBan,
          FORMAT_TIME.dateTime_4
        ),
      };
      const res = await employeeService.updateTextAway(params);
      if (res.code === "400") {
        Notification("error", res.message);
      } else {
        Notification("success", `Đã chỉnh sửa văn bản đến thành công  `);
      }
      setLoading(false);
      getListApi();
      closeModal();
    } catch (error) {
      setLoading(false);
      Notification("error", `Đã có lỗi khi sửa văn bản đến `);
    }
  };
  useEffect(() => {
    form.setFieldsValue({
      ...detailDoc,
      ngayThangNamVanBan: convertIosStringToDateObjectDayjs(
        detailDoc?.ngayThangNamVanBan
      ),
    });
  }, [detailDoc]);
  const onFinish = (values) => {
    if (detailDoc) {
      updateStore();
    } else {
        submit();
    }
  };
  // const getList = async (type = "VAN_BAN_DI") => {
  //   setLoadingFile(true);
  //   try {
  //     const res = await employeeService.getListFilesAway(type);
  //     const newRes = res.map(item => {
  //       return {
  //         ...item,
  //         tenFile: getDesiredFileName(item.tenFile),
  //       };
  //     });
  //     setLoadingFile(false);

  //     setFile(newRes);
  //   } catch (error) {
  //     Notification("error", "Lỗi khi lấy file");
  //     setLoadingFile(false);
  //   }
  // };

  // useEffect(() => {
  //   getList();
  // }, [idTable]);
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]}>
              <InputFields data={fieldInfo}></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button onClick={closeModal}>Hủy</Button>
                  <Button htmlType="submit" type="primary">
                    Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
      <ModalCustom ref={modalRef} title={"Danh sách file"}>
        <Space direction="vertical" style={{width: "100%"}}>
          <Spin spinning={loadingFile}>
            {/* <List
              className="list-item"
              dataSource={[{...infoFile, key: 1}]}
              //dataSource={file}
              renderItem={(item: any) => (
                <List.Item
                  style={{padding: "10px 0"}}
                  actions={[
                    <Tooltip title="Tải xuống">
                      <Button
                        icon={<DownloadOutlined rev={undefined} />}
                        onClick={() => handleDownload(item)}
                      />
                    </Tooltip>,

                    <Tooltip title="Xem chi tiết">
                      <Button
                        icon={<EyeOutlined rev={undefined} />}
                        onClick={() => handlePreview(item)}
                      />
                    </Tooltip>,
                    <Tooltip title="Xóa">
                      <Button
                        type="default"
                        danger
                        icon={<DeleteOutlined rev={undefined} />}
                        onClick={() => handleDelete(item)}
                      />
                    </Tooltip>,
                  ]}
                >
                  <List.Item.Meta title={<div>{item?.tenFile}</div>} />
                </List.Item>
              )}
            /> */}
          </Spin>
        </Space>
      </ModalCustom>
    </div>
  );
};

export default InfoDoc;
